import Container from '../../Basic/Container/Container.mjs';
import styled, { css } from 'styled-components';

const animationCss = css `
  transition: background ${({ theme }) => theme.animation.duration.quick1}
    ${({ theme }) => theme.animation.easing.expressive.standard};
`;
const TooltipContainer = styled(Container) `
  box-sizing: border-box;
  padding: 0 60px;
  width: 100%;
  max-width: ${props => props.theme.breakpoints.max};
  margin: 0 auto;

  @media screen and (max-width: ${props => props.theme.breakpoints.lg}) {
    padding: 0 16px;
  }
`;
const Tooltip = styled.div `
  position: absolute;
  z-index: ${props => props.theme.zIndex.modal};
  max-width: 177px;
  transform: translate(-6px, -9px);
  box-shadow: ${props => props.theme.shadows.topNavigationTooltip};
  border-radius: 4px;

  div {
    background-color: ${props => props.theme.colors.backgroundColor};
    box-sizing: border-box;
    display: flex;
    padding: 8px 10px;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    ${animationCss}
  }

  svg {
    flex-shrink: 0;
  }

  &:before {
    content: '';
    width: 20px;
    z-index: ${props => props.theme.zIndex.negative};
    top: -4px;
    box-shadow: ${props => props.theme.shadows.topNavigationTooltip};
    left: 8px;
    border-radius: 2px;
    height: 20px;
    background-color: ${props => props.theme.colors.backgroundColor};
    position: absolute;
    transform: rotate(45deg);
    ${animationCss}
  }
`;

export { Tooltip, TooltipContainer };
//# sourceMappingURL=TopNavigationTooltip.styles.mjs.map
